$(document).ready(function () {

  function hasEmployeeTag() {
    return Array.isArray(window.customerTags) && window.customerTags.includes("Employee");
  }

  function startCheckoutLoading() {
    var $btn = $('#checkout-button');

    $btn.addClass("loading").prop("disabled", true);

    var $spinner = $btn.find('.loading__spinner');
    if ($spinner.length) {
      $spinner.removeClass("hidden");
    }
  }

  function resetCheckoutButton() {
    var $btn = $('#checkout-button');

    $btn.removeClass("loading").prop("disabled", false);

    var $spinner = $btn.find('.loading__spinner');
    if ($spinner.length) {
      $spinner.addClass("hidden");
    }
  }

  $(document).on('click', '#checkout-button', function (e) {

    var $btn = $('#checkout-button');
    if ($btn.prop("disabled")) return;

    if (!hasEmployeeTag()) {
      e.preventDefault();
      $('#checkout-popup').css('display', 'flex');
      return;
    }

    e.preventDefault();
    startCheckoutLoading();

    updateCartAndCheckout();
  });

  $('#continue-checkout').on('click', function () {
    $('#checkout-popup').hide();
    window.location.href = '/checkout';
  });

  $('#close-popup').on('click', function () {
    $('#checkout-popup').hide();
  });

  function updateCartAndCheckout() {

    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {

        const updateData = {
          note:
            'Employee Number: ' + document.getElementById('cust-token-emp').value +
            '\r\n\r\nCompany: ' + document.getElementById('cust-token-comp').value +
            '\r\n\r\nPickup Location: \r\n' +
            document.getElementById('pu-location')?.value +
            '\r\n\r\nInstruction: \r\n' +
            document.getElementById('CartDrawer-Note')?.value,
          updates: {}
        };

        return fetch('/cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify(updateData)
        });

      })
      .then(response => response.json())
      .then(cart => {
        window.location.href = '/checkout';
      })
      .catch(error => {

        console.error('Checkout error:', error);

        resetCheckoutButton();

        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong. Please try again."
        });

      });
  }

});